import { Option } from '@mom/ui';

export enum Country {
  Ireland = '105',
  NorthernIreland = '163',
  Other = '3'
}

export const CountryOptions: Option<string>[] = [
  { value: Country.Ireland, text: 'Republic of Ireland' },
  { value: Country.NorthernIreland, text: 'Northern Ireland' },
  { value: Country.Other, text: 'Other' }
];

export const CountryLabels: Record<Country, string> = {
  [Country.Ireland]: 'Republic of Ireland',
  [Country.NorthernIreland]: 'Northern Ireland',
  [Country.Other]: ''
};

export const CountryPrefix: Record<Country, string> = {
  [Country.Ireland]: '+353',
  [Country.NorthernIreland]: '+44',
  [Country.Other]: ''
};

export const CountryCodeOptions: Option<string>[] = [
  { value: '+353', text: 'Republic of Ireland' },
  { value: '+44', text: 'Northern Ireland' }
];
